import { Col, Modal, Row } from 'react-bootstrap'
import { useIsMutating } from 'react-query'
import { KTSVG } from '../../../_metronic/helpers'
import { graphqlRequestClient, queryClient } from '../../../queries/client'
import {
  RemoveEeThemeFilterMutation,
  useRemoveEeThemeFilterMutation,
  useGetEeThemesQuery,
  RemoveEeThemeFilterMutationVariables,
} from '../../../generated/graphql'
import Toast, { ToastType } from '../../../utils/toast'

type Props = {
  showRemoveModal: boolean
  toggleRemoveModal: () => void
  theme: any
  filters: any
}

function RemoveEETheme({ showRemoveModal, toggleRemoveModal, theme, filters }: Props) {
  const removeMutate = useRemoveEeThemeFilterMutation<Error>(
    graphqlRequestClient,
    {
      onSuccess: (data: RemoveEeThemeFilterMutation, _variables: RemoveEeThemeFilterMutationVariables, _context: unknown) => {
        queryClient.invalidateQueries(useGetEeThemesQuery.getKey())
        Toast(data.removeEEThemeFilter.message, ToastType.success)
        toggleRemoveModal()
      },
      onError: (error: any) => Toast(error.response.errors[0].message, ToastType.error),
    },
    {}
  )

  function handleSubmit(e: any) {
    e.preventDefault()
    e.stopPropagation()
    removeMutate.mutate({ input: { id: theme.id } })
  }

  return (
    <Modal id='kt_modal_remove_theme' aria-hidden='true' show={showRemoveModal} onHide={toggleRemoveModal}>
      <form onSubmit={handleSubmit}>
        <Modal.Header className='p-2'>
          <Modal.Title className='ps-5'>Remove Theme Filter</Modal.Title>
          <button
            className='btn btn-sm btn-icon btn-active-light-primary'
            type='button'
            data-bs-toggle='tooltip'
            title='Close'
            onClick={toggleRemoveModal}
          >
            <KTSVG className='svg-icon-1' path='/media/icons/duotune/arrows/arr061.svg' />
          </button>
        </Modal.Header>
        <Modal.Body>
          <div className='me-n7 pe-7'>
            <div className='fs-3 pb-6'>Are you sure you want to remove this theme filter?</div>
            <Row>
              <Col>ID:</Col>
              <Col>{theme && theme.id}</Col>
            </Row>
            <Row>
              <Col>Name:</Col>
              <Col>{theme && theme.name}</Col>
            </Row>
            <Row>
              <Col>Filter:</Col>
              <Col>{theme && filters.find((f: any) => f.id === theme.filterId).name}</Col>
            </Row>
            {theme && theme.min && (
              <Row>
                <Col>Range:</Col>
                <Col>{theme.min + ' to ' + theme.max}</Col>
              </Row>
            )}
            {theme && theme.inList && (
              <Row>
                <Col>List:</Col>
                <Col>
                  {theme.inList.split(',').map((tag: any, i: any) => (
                    <span key={i} className='badge badge-light-info fw-semibold me-1'>
                      {tag}
                    </span>
                  ))}
                </Col>
              </Row>
            )}
          </div>
        </Modal.Body>
        <Modal.Footer className='p-2'>
          <div className='d-flex justify-content-between'>
            <button type='button' className='btn btn-sm btn-secondary me-3' onClick={toggleRemoveModal}>
              Cancel
            </button>
            <button type='submit' className='btn btn-sm btn-primary' disabled={useIsMutating() > 0}>
              {useIsMutating() === 0 && 'Remove Theme Filter'}
              {useIsMutating() > 0 && (
                <span className='indicator-progress' style={{ display: 'block' }}>
                  Please wait... <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                </span>
              )}
            </button>
          </div>
        </Modal.Footer>
      </form>
    </Modal>
  )
}

export default RemoveEETheme
